import baseGetTag from "./component-library278.mjs";
import isObjectLike from "./component-library279.mjs";
var argsTag = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}
export {
  baseIsArguments as default
};
